import React from 'react';
import { useRecoilState } from 'recoil';
import { defaultIsMobile } from '../../../../../../utils/states/isMobile.state';

import ApplicationsBlocks from './components/Blocks/ApplicationsBlocks';
import ApplicationsTable from './components/Table/ApplicationsTable';
import { FilterValues } from '../CustomFilterModal/CustomFilterModal';
type Props = {
  filter?: FilterValues | null;
};
export const Content: React.FC<Props> = ({ filter }) => {
  const [version] = useRecoilState(defaultIsMobile);
  const isMobile = version.isMobile;

  return <div>{isMobile ? <ApplicationsBlocks filter={filter}/> : <ApplicationsTable filter={filter}/>}</div>;
};
